module.exports = __webpack_public_path__ + "6c74bf31f934c88156399e9f2418ab5c.MP3";